(ns minorodata.components.connections.extract-output-preview
  (:require
   [clojure.string :as str]
   [minorodata.app.handlers :refer [dispatch]]
   [ui.data-grid.preview :as data-grid-preview]
   [minorodata.components.spinner.core :refer [spinner-lucide]]
   [re-posh.core :as re-posh]
   [react :as react]
   [ui.typography :as typography]))

(defn output-preview-table [{:keys [preview dark-mode?]}]
  (let [{:keys [headers rows]} preview
        height       (str (max 100 (min (+ 3 (* 25 (inc (count rows)))) 300)) "px")
        popup-parent (.querySelector js/document "[data-extract-details-ag-popup-parent]")]
    [:f> data-grid-preview/table
     {:headers      headers
      :rows         rows
      :dark-mode?   dark-mode?
      :height       height
      :column-width 270
      :sortable?    true
      :filterable?  true
      :resizable?   true
      :row-numbers? true
      :popup-parent popup-parent}]))

(defn output-preview-query [output-table]
  (str "SELECT * FROM " output-table " LIMIT 1000;"))

(defn output-preview [{:keys [output-table]}]
  (let [[preview set-preview]   (react/useState nil)
        [loading? set-loading?] (react/useState false)
        dark-mode?              @(re-posh/subscribe [:app/prop :app/dark-mode?])]

    (react/useEffect
     (fn []
       (let [cancelled? (atom false)]
         (set-preview nil)
         (set-loading? false)

         (when-not (str/blank? output-table)
           (set-loading? true)
           (dispatch [:sql-console.api/post-query
                      {:query (output-preview-query output-table)}
                      {:on-success    (fn [response]
                                        (when-not @cancelled?
                                          (set-preview {:headers (ffirst (:data response))
                                                        :rows    (next (first (:data response)))})
                                          (set-loading? false)))
                       :on-failure    (fn []
                                        (when-not @cancelled?
                                          (dispatch [:app.events/add-snack
                                                     :error
                                                     "Failed to fetch output preview"])
                                          (set-preview nil)
                                          (set-loading? false)))
                       :skip-console? true}]))

         (fn []
           (reset! cancelled? true))))
     #js [output-table])

    [:section
     [typography/h3 "Output preview"]

     (cond
       (str/blank? output-table)
       [typography/p {:class "mt-2 text-kleene-text-secondary"}
        "No output table"]

       loading?
       [:div {:class "mt-4 flex items-center gap-2 text-kleene-text-secondary"}
        [spinner-lucide]
        "Loading..."]

       (empty? (:rows preview))
       [typography/p {:class "mt-2 text-kleene-text-secondary"}
        "No data"]

       :else
       [:div {:class "mt-2 w-full overflow-x-auto"}
        [output-preview-table {:preview    preview
                               :dark-mode? dark-mode?}]])]))
